export const isContained = (s: string, substring: string): boolean => {
    return s.toLowerCase().includes(substring.toLowerCase());
}

export const mergeArrays = <T>(a: Array<T>, b: Array<T>): Array<T> => {
    if (!a && !b) {
        return []
    }
    if (!a || !b) {
        return a || b
    }
    if (a.length === 0) {
        return b
    }
    if (b.length === 0) {
        return a
    }
    const merged = [...a, ...b]
    return merged.filter((item, i, ar) => ar.indexOf(item) === i);
}